module.exports = __webpack_public_path__ + "img/bad-session-4.e65a00f7.png";